import { ref } from 'vue';
import { Toast } from 'bootstrap';

export function useToast() {
  const toastTitle = ref('');
  const toastMessage = ref('');
  const toastInstance = ref(null);
  const autoCloseTimeout = ref(null);

  const closeToast = () => {
    if (toastInstance.value) {
      toastInstance.value.hide();
    }
    if (autoCloseTimeout.value) {
      clearTimeout(autoCloseTimeout.value);
      autoCloseTimeout.value = null;
    }
  };

  const showToast = (title, message) => {
    toastTitle.value = title;
    toastMessage.value = message;

    if (!toastInstance.value) {
      toastInstance.value = new Toast(document.getElementById('feedbackToast'), { autohide: false });
    }

    toastInstance.value.show();

    // Configurar el auto cierre del toast después de 3 segundos
    autoCloseTimeout.value = setTimeout(() => {
      closeToast();
    }, 3000);
  };

  return {
    toastTitle,
    toastMessage,
    showToast,
    closeToast
  };
}